function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSuccessful = function SvgSuccessful(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 126 126",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 63,
    r: 63,
    style: {
      fill: "#89c958"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9 83.4c-.2 0-.4 0-.6-.1l-.6-.3-18.4-14.8c-.5-.4-.8-1-.8-1.6 0-.4.1-.9.4-1.2.7-.9 1.9-1 2.8-.3l16.8 13.5L84 43.3c.7-.9 1.9-1.1 2.8-.4.5.4.8 1 .8 1.6 0 .4-.1.8-.4 1.2L59.5 82.5c-.2.2-.3.4-.5.5s-.5.2-.7.3c-.2 0-.3.1-.4.1",
    style: {
      fill: "#fff"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSuccessful);
export default ForwardRef;